<template>
    <div class="transaction_h">
        <div class="renew_top">
            <!-- deduction_mode  1,2 FEB 4 BETH -->
            <div v-if="row_data.deduction_mode!=3">
                {{ $t('beth_text.Automatic_annual_renewal') }}
                <el-switch
                    :disabled="[1,2].includes(row_data.deduction_mode)"
                    v-model="auto_fee"
                    @change="change_auto_fee"
                    active-color="#00C08D">
                </el-switch>
            </div>
            <template v-if="row_data.show_status==1">
                <!-- 1自动 2确认自动 3停止 4用户 -->
                <div class="switch_txt">
                    <!-- 文字 10 -->
                    <div v-if="row_data.deduction_mode==3">
                        <!-- Your card has been indicated for non-renewal and will expire on {{annual_fee_end_time}}, please contact customer service should you require further assistance. -->
                        {{ $t('beth_text.Your_been',{
                            annual_fee_end_time:overall_time2(row_data.annual_fee_end_time),
                        }) }}
                    </div>
                    <div v-else>
                        <!-- 文字 9 -->
                        <div v-if="!auto_fee">
                            <!-- Unticked: Please make payment of {{payment_amount}} USDC/T (for {{payment_month}} months) by {{annual_fee_end_time}} to avoid cancellation of your card. -->
                            {{ $t('beth_text.Unticked_Please',{
                                payment_amount:row_data.payment_amount,
                                payment_month:row_data.payment_month,
                                payment_date:overall_time2(row_data.payment_date),
                            }) }}
                        </div>
                        <div v-else>
                            <div v-if="[1,2].includes(row_data.deduction_mode)">
                                <!-- 文字显示 8  -->
                                <div>
                                    <!-- Ticked (if FEB account): Your next membership fee of {{payment_amount}} USDC/T (for {{payment_month}} months) will be automatically deducted from your parent corporate account on {{annual_fee_end_time}}.	 -->
                                    {{ $t('beth_text.Ticked_FEB',{
                                        payment_amount:row_data.payment_amount,
                                        payment_month:row_data.payment_month,
                                        payment_date:overall_time2(row_data.payment_date),
                                    }) }}
                                </div>
                            </div>
                            <div v-else>
                                <div>
                                    <!-- Ticked (if Beth Account): Your next membership fee of {{payment_amount}} USDC/T (for {{payment_month}} months) will be automatically deducted on {{annual_fee_end_time}} from your Beth wallet balance. Please ensure sufficient balance to avoid service disruptions. -->
                                    {{ $t('beth_text.Ticked_Beth',{
                                        payment_amount:row_data.payment_amount,
                                        payment_month:row_data.payment_month,
                                        payment_date:overall_time2(row_data.payment_date),
                                    }) }}
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>

                <div class="switch_txt">
                    <div>
                        <!-- Current Annual Membership Fee :{{row_data.current_amount }} USDT/C -->
                        {{ $t('beth_text.Current_Annual',{
                            current_amount:row_data.current_amount,
                        }) }}
                    </div>
                </div>
            </template>
        </div>
        <div class="t_h2">
            <div class="t_h2_table zdy_tab_header">
                <el-table :data="tableData" stripe style="width: 100%">
                     <el-table-column
                        label="#"
                        type="index"
                        width="50">
                    </el-table-column>

                    <el-table-column :label="$t('beth_text.Card_No')" min-width="100">
                        <span slot-scope="props">
                            {{ props.row.card_number||"-" }}
                        </span>
                    </el-table-column>

                    <el-table-column :label="$t('beth_text.Expiry_Date')" min-width="110">
                        <span slot-scope="props">
                            {{ props.row.expire_date||"-" }}
                        </span>
                    </el-table-column>

                    <el-table-column :label="$t('beth_text.Term_Start_Date')" min-width="110">
                        <span slot-scope="props">
                            {{ props.row.term_start_date||"-" }}
                        </span>
                    </el-table-column>

                    <el-table-column :label="$t('beth_text.Term_End_Date')" min-width="100">
                        <span slot-scope="props">
                            {{ props.row.term_end_date||"-" }}
                        </span>
                    </el-table-column>

                    <el-table-column :label="$t('beth_text.Auto_Renewal_Date')" min-width="100">
                        <span slot-scope="props">
                            {{ props.row.payment_date||"-" }}
                        </span>
                    </el-table-column>

                    <el-table-column :label="$t('beth_text.Payment_Months')" min-width="120">
                        <span slot-scope="props">
                            <span>{{ props.row.payment_month }}</span>
                        </span>
                    </el-table-column>

                    <el-table-column :label="$t('beth_text.Membership_Fee_Due')+'(USDC/T)'" min-width="120">
                        <span slot-scope="props">
                            <span v-if="props.row.status==0">-</span>
                            <span v-else>{{ props.row.payment_amount||"-" }}</span>
                        </span>
                    </el-table-column>

                    <el-table-column :label="$t('beth_text2.Renewal_Status')" min-width="120">
                        <span slot-scope="props">
                        <!-- "": 1, //付款状态 0免费 1支付 2待付 3逾期 4未付(取消) 5即将到期 接口返回“-” 直接显示 -->
                        <span v-if="props.row.status==0">{{$t('beth_text2.free_charge')}}</span>
                        <span v-else-if="props.row.status==1">{{$t('beth_text2.pay1')}}</span>
                        <span v-else-if="props.row.status==2">{{$t('beth_text2.Pending_status')}}</span>
                        <span v-else-if="props.row.status==3">{{$t('beth_text2.overdue')}}</span>
                        <span v-else-if="props.row.status==4">{{$t('beth_text2.Discontinued')}}</span>
                        <span v-else-if="props.row.status==5">{{$t('beth_text2.due_soon')}}</span>
                        <span v-else>{{props.row.status}}</span>
                        </span>
                    </el-table-column>

                    <!-- <el-table-column :label="$t('beth_text.Payment_Status')" min-width="100">
                        <span slot-scope="props">
                            <span v-if="props.row.status==0">{{$t('beth_text.Free_annual_fee')}}</span>
                            <span v-else>
                                付款状态 1已付 2待付 3逾期 4未付(取消) 5即将到期
                                <span v-if="props.row.status==1">{{$t('beth_text.pay1')}}</span>
                                <span v-else-if="props.row.status==2">{{$t('beth_text.pay_another')}}</span>
                                <span v-else-if="props.row.status==3">{{$t('beth_text.overdue')}}</span>
                                <span v-else-if="props.row.status==4">{{$t('beth_text.unpaid')}}</span>
                            </span>
                        </span>
                    </el-table-column> -->

                    <el-table-column :label="$t('beth_text.Payment_Date')" min-width="100">
                        <span slot-scope="props">
                            {{ props.row.actually_payment_date||"-" }}
                        </span>
                    </el-table-column>

                    <el-table-column :label="$t('bank_card.operate')">
                        <span slot-scope="props">
                            <!-- 2和3 5 都显示 -->
                            <span v-if="[2,3,5].includes(props.row.status) && props.row.status!=0 && row_data.deduction_mode==4">
                                <span class="pay_icon" @click="open_renew_dlg(props.row.payment_amount,props.row.uni_tx_id)">{{$t('beth_text.pay')}}</span>
                            </span>
                            <span v-else>-</span>
                        </span>
                    </el-table-column>

                    <el-table-column :label="$t('bank_card.describe')">
                        <span slot-scope="props">
                            <span class="look_icon" v-if="props.row.description" @click="open_look_info_dlg(props.row.description)">{{$t('bank_card.View')}}</span>
                            <span v-else>-</span>
                        </span>
                    </el-table-column>

                </el-table>
                <!-- <el-pagination v-if="tableData.length > 0" background :page-sizes="[10, 20, 30, 40]" :page-size="limit" :current-page.sync="currentPage" layout="prev, pager, next" :total="page_total" @current-change="current_change"></el-pagination> -->
            </div>
        </div>

        <!-- Pay 弹框 -->
        <el-dialog
        :title="$t('beth_text.pay')"
        :visible.sync="renew_dlg"
        custom-class="dlg element_input add_dlg"
        append-to-body
        center
        width="500px"
        >
        <div class="dlg_body">
            <div class="d_body">
                <el-form class="dlg_form2 rep_form" label-position="top">
                    <div class="pay_txt">
                        <!-- 本次需要支付 {{ payment_amount }} USDT/C，是否支付？ -->
                        {{$t('beth_text.need_to_pay',{payment_amount:payment_amount})}}
                    </div>
                </el-form>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="renew_dlg = false" class="cancel_btn border_set_color2">
                {{$t('main.text7')}}
            </el-button>
            <el-button type="primary" @click="renew_dlg_confirm" class="confirm_btn">
                {{$t('main.text130')}}
            </el-button>
        </span>
        </el-dialog>

        <!-- 查看 弹框 -->
        <el-dialog
        :title="$t('bank_card.View')"
        :visible.sync="look_info_dlg"
        custom-class="dlg element_input add_dlg"
        append-to-body
        center
        width="500px"
        >
        <div class="dlg_body">
            <div class="d_body">
            <el-form class="dlg_form2 rep_form" label-position="top">
                <div class="card_set_title">{{look_info_des}}</div>
            </el-form>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            &nbsp;
        </span>
        </el-dialog>

        <!-- 点击续费按钮  扣FEB的 弹框 -->
        <el-dialog
        :title="$t('beth_text.pay')"
        :visible.sync="deduct_feb_dlg"
        custom-class="dlg element_input add_dlg"
        append-to-body
        center
        width="500px"
        >
        <div class="dlg_body">
            <div class="d_body">
                <el-form class="dlg_form2 rep_form" label-position="top">
                    <div class="pay_txt">
                        <!-- 您所属的FEB账户需要为这笔交易支付{payment_amount}美元C/T。确认继续？ -->
                        {{$t('beth_text.feb_account',{payment_amount:payment_amount})}}
                    </div>
                </el-form>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="deduct_feb_dlg = false" class="cancel_btn border_set_color2">
                {{$t('main.text7')}}
            </el-button>
            <el-button type="primary" @click="deduct_feb_dlg_confirm" class="confirm_btn">
                {{$t('main.text130')}}
            </el-button>
        </span>
        </el-dialog>

    </div>
</template>
<script>
import { renewList,annualSetting,renew,getAnnualConfig } from "@/api/api";
export default {
    data() {
        return {
            tableData: [],
            auto_fee:true,

            look_info_des:"",
            renew_dlg:false,
            look_info_dlg:false,

            row_data:{},
            payment_amount:'',
            uni_tx_id:"",
            card_id:this.$route.query.card_id,
            deduct_feb_dlg:false,
        };
    },
    beforeDestroy() {
        sessionStorage.removeItem("top_title_name");
    },
    mounted() {
        sessionStorage.setItem("top_title_name", this.$t('beth_text.renew'));
        this.get_list();
    },
    methods: {
        async get_list() {
            const res = await renewList({card_id:this.card_id});
            if(res.data.code!=200){
                return this.message.ismessage('error',res.data.msg);
            }
            this.tableData = res.data.data;

            const res2 = await getAnnualConfig({card_id:this.card_id});
            if(res2.data.code!=200){
                return this.message.ismessage('error',res.data.msg);
            }
            this.row_data = res2.data.data;
            // annual_auto_renew 是否自动续费
            if(this.row_data.annual_auto_renew==0){
                this.auto_fee = false;
            }else{
                this.auto_fee = true;
            }
            // deduction_mode 1自动 2确认自动 3停止 4用户
            
        },
        
        open_look_info_dlg(des){
            this.look_info_des = des;
            this.look_info_dlg = true;
        },
        async change_auto_fee(v){
            const res = await annualSetting({
                card_id:this.card_id,
                status:v?1:0,
            });
            if(res.data.code!=200){
                return this.message.ismessage('error',res.data.msg);
            }
            this.message.ismessage('success',this.$t('beth_text.successfully_set'));
            this.get_list();
        },
        open_renew_dlg(payment_amount,uni_tx_id){
            this.payment_amount = payment_amount;
            this.uni_tx_id = uni_tx_id;
            let d = this.tableData;
            let index = d.findIndex(item => item.uni_tx_id == uni_tx_id);
            const d2 = d.slice(0,index);
            if(!d2.every((v)=>[0,1].includes(v.status))){
                return this.message.ismessage('error',this.$t('beth_text.renewal_first'));
            }

            this.renew_dlg=true;
        },
        deduct_feb_dlg_confirm(){
            this.deduct_feb_dlg=false;
            this.renew_dlg=true;
        },
        async renew_dlg_confirm(){
            const res = await renew({
                renew_id:this.uni_tx_id
            });
            if(res.data.code!=200){
                return this.message.ismessage('error',res.data.msg);
            }
            this.message.ismessage('success',this.$t('beth_text.payment_success'));
            this.renew_dlg=false;
            this.get_list();
        }
        
    },
};
</script>

<style scoped>
.switch_txt>div{
    margin: 15px 0;
    line-height: 20px;
}
.pay_icon{
    cursor: pointer;
    color: #00C18E;
}
.look_icon{
    cursor: pointer;
    color: #1890FF;
}

.card_set_title{
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: initial;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 15px;
}
.card_set_title span{
  color: #fff;
}
.pay_txt{
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    line-height: initial;
    text-align: center;
}
.t_h2_table >>> .el-table__body-wrapper::-webkit-scrollbar {
  height: 5px;
}
.t_h2_table >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #00c18e;
}
</style>
